import styles from './Navbar.module.css';
import { Link, useLocation } from 'react-router-dom';
import {
  APPLICATIONS,
  AUTH,
  CARDS,
  PAYMENTS,
  SETTINGS,
  TG_SESSIONS,
  SUPPORT,
  WITHDRAWAL,
  ANALYST_METRICS,
  ANALYST_BALANCES,
  ANALYST_RECONCILIATION,
  ANALYST_SETTLEMENTS,
} from '../../utils/constants/routes';
import { useVisible } from '../../utils/hooks/useVisible';
import { useGetUserTypeQuery } from '../../redux/services/SupportApi';

export const Navbar = () => {
  const location = useLocation();
  const { notVisible } = useVisible();
  const { data: userType } = useGetUserTypeQuery(undefined, { skip: notVisible });
  // support admins and analysts have no trader data: trader pages would only bounce to "403"
  const supportOnly = localStorage.getItem('role') === 'admin';
  const analystOnly = localStorage.getItem('role') === 'analyst';
  const analystLinks = [
    { to: ANALYST_METRICS, name: 'Метрики' },
    { to: ANALYST_BALANCES, name: 'Балансы' },
    { to: ANALYST_RECONCILIATION, name: 'Сверка' },
    { to: ANALYST_SETTLEMENTS, name: 'Сеттлменты' },
  ];

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('role');
  };

  if (notVisible) return null;
  return (
    <div className={styles.navBar}>
      <div className={styles.navbarInner}>
        <div className={styles.logo}>
          {' '}
          <img className={styles.logoImg} src='/logo.svg' alt='logo' />
        </div>
        {!supportOnly && !analystOnly && (<>
        <Link to={CARDS} className='link-style'>
          <div className={location.pathname === CARDS ? styles.activeButton : styles.button}>
            <img
              src={location.pathname === CARDS ? '/cards_icon_active.png' : '/cards_icon.png'}
              alt={'cards_icon'}
            />{' '}
            Реквизиты
          </div>
        </Link>
        <Link to={PAYMENTS} className='link-style'>
          <div className={location.pathname === PAYMENTS ? styles.activeButton : styles.button}>
            <img
              src={
                location.pathname === PAYMENTS
                  ? '/replenishment_icon_active.png'
                  : '/replenishment_icon.png'
              }
              alt={'replenishment_icon'}
            />{' '}
            Баланс
          </div>
        </Link>
        <Link to={APPLICATIONS} className='link-style'>
          <div className={location.pathname === APPLICATIONS ? styles.activeButton : styles.button}>
            <img
              src={
                location.pathname === APPLICATIONS
                  ? '/application_icon_active.svg'
                  : '/application_icon.svg'
              }
              alt={'application'}
            />{' '}
            Пополнение
          </div>
        </Link>
        <Link to={WITHDRAWAL} className='link-style'>
          <div className={location.pathname === WITHDRAWAL ? styles.activeButton : styles.button}>
            <img
              src={
                location.pathname === WITHDRAWAL
                  ? '/withdraw_icon_active.svg'
                  : '/withdraw_icon.svg'
              }
              alt={'settings_icon'}
            />{' '}
            Вывод
          </div>
        </Link>
        <Link to={SETTINGS} className='link-style'>
          <div className={location.pathname === SETTINGS ? styles.activeButton : styles.button}>
            <img
              src={
                location.pathname === SETTINGS ? '/phone_mobile_icon.svg' : '/phone_mobile_icon.svg'
              }
              alt={'settings_icon'}
            />{' '}
            Устройства
          </div>
        </Link>
        <Link to={TG_SESSIONS} className='link-style'>
          <div className={location.pathname === TG_SESSIONS ? styles.activeButton : styles.button}>
            <img
              src={location.pathname === TG_SESSIONS ? '/telegram_icon_active.svg' : '/telegram_icon.svg'}
              alt={'telegram_icon'}
            />{' '}
            Сессии в ТГ
          </div>
        </Link>
        </>)}
        {(userType === 'analyst' || analystOnly) &&
          analystLinks.map((link) => (
            <Link key={link.to} to={link.to} className='link-style'>
              <div className={location.pathname === link.to ? styles.activeButton : styles.button}>
                <img
                  src={location.pathname === link.to ? '/application_icon_active.svg' : '/application_icon.svg'}
                  alt={'analyst_icon'}
                />{' '}
                {link.name}
              </div>
            </Link>
          ))}
        {(userType === 'admin' || supportOnly) && (
          <Link to={SUPPORT} className='link-style'>
            <div className={location.pathname === SUPPORT ? styles.activeButton : styles.button}>
              <img
                src={location.pathname === SUPPORT ? '/application_icon_active.svg' : '/application_icon.svg'}
                alt={'support_icon'}
              />{' '}
              Саппорт
            </div>
          </Link>
        )}
        <Link to={AUTH} className='link-style'>
          <div className={styles.button} style={{ color: '#FE5B37' }} onClick={logout}>
            <img src={'/logout_icon.png'} alt={'logout_icon'} /> Выход
          </div>
        </Link>
      </div>
    </div>
  );
};
